// extracted by mini-css-extract-plugin
export var bubble = "_3g-0";
export var container = "_3g-f";
export var contrastBorder = "_3g-g";
export var greyOut = "_3g-2";
export var initialsColor0 = "_3g-3";
export var initialsColor1 = "_3g-4";
export var initialsColor10 = "_3g-d";
export var initialsColor11 = "_3g-e";
export var initialsColor2 = "_3g-5";
export var initialsColor3 = "_3g-6";
export var initialsColor4 = "_3g-7";
export var initialsColor5 = "_3g-8";
export var initialsColor6 = "_3g-9";
export var initialsColor7 = "_3g-a";
export var initialsColor8 = "_3g-b";
export var initialsColor9 = "_3g-c";
export var initialsWrapper = "_3g-1";
export var large = "_3g-l";
export var medium = "_3g-k";
export var mediumSmall = "_3g-j";
export var mediumSmallMedium = "_3g-o";
export var micro = "_3g-h";
export var small = "_3g-i";
export var tiny = "_3g-n";
export var xTiny = "_3g-m";